
export const CmsBackground = () => {
	return (
		<div className="absolute inset-0 bg-sv-dark opacity-90">
		</div>
	);
}

export default CmsBackground;
